import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.requests)

export const REQUESTS_INSTANCE = service.instanceKey

export const REQUESTS_ENDPOINTS = {
  // Admin request detail
  ADMIN_GET_REQUEST: "/admin/requests/getemployeerequest",
  // Employee request actions
  ADD_LOAN: "/employee/requests/add_loanrequest",
  ADD_LEAVE: "/employee/requests/add_leaverequest",
  ADD_EXIT: "/employee/requests/add_exitrequest",
  ADD_REDEPLOYMENT: "/employee/requests/add_redeploymentrequest",
  ADD_DOCUMENT: "/employee/requests/add_documentrequest",
  ADD_ADVANCE: "/employee/requests/add_advancerequest",
  UPLOAD_DOCUMENT: "/employee/requests/upload_document",
  // Employee request policies
  GET_LOAN_POLICIES: "/employee/requests/getloanpolicies",
  GET_LEAVE_POLICIES: "/employee/requests/getleavepolicies",
  GET_EXIT_POLICIES: "/employee/requests/getexitpolicies",
  GET_REDEPLOYMENT_POLICIES: "/employee/requests/getredeploymentpolicies",
  GET_DOCUMENT_POLICIES: "/employee/requests/getdocumentpolicies",
  GET_ADVANCE_POLICIES: "/employee/requests/getadvancepolicies",
  // Admin request listings
  ADMIN_LOAN_POLICIES: "/admin/requests/getloanpolicies",
  ADMIN_LOAN_REQUESTS: "/admin/requests/selectloanrequests",
  SELECT_APPROVAL_LOAN_REQUESTS: "/requests/selectloanrequests",
  ADMIN_LEAVE_POLICIES: "/admin/requests/getleavepolicies",
  ADMIN_LEAVE_REQUESTS: "/admin/requests/selectleaverequests",
  SELECT_APPROVAL_LEAVE_REQUESTS: "/requests/selectleaverequests",
  ADMIN_EXIT_POLICIES: "/admin/requests/getexitpolicies",
  ADMIN_EXIT_REQUESTS: "/admin/requests/selectexitrequests",
  SELECT_APPROVAL_EXIT_REQUESTS: "/requests/selectexitrequests",
  ADMIN_EXIT_SCHEDULES: "/admin/requests/selectexitschedules",
  ADMIN_EXIT_SURVEYS: "/admin/requests/selectexitsurveys",
  ADMIN_ADVANCE_REQUESTS: "/admin/requests/selectadvancerequests",
  ADVANCE_REQUESTS: "/requests/selectadvancerequests",
  SELECT_APPROVAL_ADVANCE_REQUESTS: "/requests/selectadvancerequests",
  UPDATE_LEAVE_BALANCE: "/admin/requests/update_leavebalance",
  SELECT_LEAVE_REQUESTS: "/employee/requests/selectleaverequests",
  SELECT_RELIEVE_REQUESTS: "/employee/requests/selectrelieverequests",
  SELECT_LEAVE_BALANCES: "/employee/requests/selectleavebalances",
  SELECT_LOAN_REQUESTS: "/employee/requests/selectloanrequests",
  SELECT_ADVANCE_REQUESTS: "/employee/requests/selectadvancerequests",
  SELECT_EXIT_REQUESTS: "/employee/requests/selectexitrequests",
  SELECT_DOCUMENT_REQUESTS: "/employee/requests/selectdocumentrequests",
  SELECT_REDEPLOYMENT_REQUESTS: "/employee/requests/selectredeploymentrequests",

  // Admin request actions
  ADMIN_ADD_LOAN: "/admin/requests/add_loanrequest",
  ADMIN_DELETE_LOAN: "/admin/requests/delete_loanrequest",
  ADMIN_DEACTIVATE_LOAN: "/admin/requests/deactivate_loanrequest",
  ADMIN_ACTIVATE_LOAN: "/admin/requests/activate_loanrequest",
  ADMIN_BATCH_REVIEW: "/admin/requests/batch_review",
  ADMIN_REVIEW: "/admin/requests/review",
  ADMIN_ADD_LEAVE: "/admin/requests/add_leaverequest",
  ADMIN_DELETE_LEAVE: "/admin/requests/delete_leaverequest",
  ADMIN_ADD_ADVANCE: "/admin/requests/add_advancerequest",
  ADMIN_DELETE_ADVANCE: "/admin/requests/delete_advancerequest",
  ADMIN_ADD_EXIT: "/admin/requests/add_exitrequest",
  ADMIN_DELETE_EXIT: "/admin/requests/delete_exitrequest",
  ADMIN_ADD_REDEPLOYMENT: "/admin/requests/add_redeploymentrequest",
  ADMIN_DELETE_REDEPLOYMENT: "/admin/requests/delete_redeploymentrequest",
  ADMIN_ADD_DOCUMENT: "/admin/requests/add_documentrequest",
  ADMIN_DELETE_DOCUMENT: "/admin/requests/delete_documentrequest",
  ADMIN_UPLOAD_DOCUMENT: "/admin/requests/upload_document",
  ADMIN_SELECT_LEAVE_PERKS: "/admin/requests/selectleaveperks",
  ADMIN_GET_MAX_LOAN_AMOUNT: "/admin/requests/getmaximumloanamount",
  ADMIN_GET_LEAVE_BALANCE: "/admin/requests/getLeaveBalance",
  ADMIN_ADD_WORKING_DAYS: "/admin/requests/addworkingdays",
  ADMIN_REDEPLOYMENT_REQUESTS: "/admin/requests/selectredeploymentrequests",
  SELECT_APPROVAL_REDEPLOYMENT_REQUESTS: "/requests/selectredeploymentrequests",
  ADMIN_DOCUMENT_REQUESTS: "/admin/requests/selectdocumentrequests",
  ADMIN_ADVANCE_DEACTIVATE: "/admin/requests/deactivate_advancerequest",
  SELECT_APPROVAL_DOCUMENT_REQUESTS: "/requests/selectdocumentrequests",
  ADMIN_ADVANCE_ACTIVATE: "/admin/requests/activate_advancerequest",
  ADMIN_GET_MAX_ADVANCE_AMOUNT: "/admin/requests/getmaximumadvanceamount",
  ADMIN_ADVANCE_POLICIES: "/admin/requests/getadvancepolicies",
  ADMIN_ADD_LEAVE_PERK: "/admin/requests/add_leaveperk",
  ADMIN_UPDATE_LEAVE_PERK: "/admin/requests/update_leaveperk",
  ADMIN_DELETE_LEAVE_PERK: "/admin/requests/delete_leaveperk",
  ADMIN_REMOVE_LEAVE_PERK: "/admin/requests/remove_leaveperk",
  ADMIN_RESTORE_LEAVE_PERK: "/admin/requests/restore_leaveperk",
  ADMIN_GET_DOC_CONTENT: "/admin/requests/getdocumentcontent",
  ADMIN_REDEPLOYMENT_POLICIES: "/admin/requests/getredeploymentpolicies",
  ADMIN_DOCUMENT_POLICIES: "/admin/requests/getdocumentpolicies",
  ADMIN_VIEW_DOCUMENT_POLICIES: "/admin/requests/view/documents",
  ADMIN_VIEW_LEAVE_POLICIES: "/admin/requests/view/leaves",
  ADMIN_ADD_LEAVE_POLICY_ITEM: "/admin/requests/add_leavepolicyitem",
  ADMIN_MISSING_LEAVE_BALANCES: "/admin/requests/selectmissingleavebalances",
  ADMIN_VIEW_LOAN_POLICIES: "/admin/requests/view/loans",
  ADMIN_VIEW_ADVANCE_POLICIES: "/admin/requests/view/salaryadvances",
  ADMIN_VIEW_EXIT_POLICIES: "/admin/requests/view/exits",
  ADMIN_VIEW_REDEPLOYMENT_POLICIES: "/admin/requests/view/redeployments",
  ADMIN_DELETE_DOCUMENT_POLICY: "/admin/requests/delete_documentpolicy",
  ADMIN_REMOVE_DOCUMENT_POLICY: "/admin/requests/remove_documentpolicy",
  ADMIN_RESTORE_DOCUMENT_POLICY: "/admin/requests/restore_documentpolicy",
  ADMIN_IMPORT_EXITS: "/admin/requests/import_exits",
  ADMIN_DOWNLOAD_BULK_EXIT_FORM:
    "/admin/requests/view/download_bulk_exit_upload_form",
  ADMIN_IMPORT_REDEPLOYMENTS: "/admin/requests/import_redeployments",
  ADMIN_DOWNLOAD_BULK_REDEPLOYMENT_FORM:
    "/admin/requests/view/download_bulk_redeployment_upload_form",
  ADMIN_LEAVE_HOLIDAYS: "/admin/requests/view/leaves",
  ADMIN_REDEPLOYMENT_DEPTS: "/admin/requests/getredeploymentdepartments",
  ADMIN_REDEPLOYMENT_ADDRESSES:
    "/admin/requests/getredeploymentofficeaddresses",
  ADMIN_REDEPLOYMENT_NOTICE_PERIOD:
    "/admin/requests/getredeploymentnoticeperiod",
  ADMIN_EXIT_NOTICE_PERIOD: "/admin/requests/getexitnoticeperiod",
  ADMIN_REDEPLOYMENT_SCHEDULES: "/admin/requests/selectredeploymentschedules",
  ADMIN_LEAVE_RELIEVERS: "/admin/requests/leaverelievers",
  EMPLOYEE_LEAVE_RELIEVERS: "/requests/leaverelievers",
  ADMIN_LEAVE_POLICIES_FOR_PERSON: "/admin/requests/getleavepolicies",
  ADMIN_POLICIES_BY_REQUEST_TYPE:
    "/admin/requests/getpoliciesbyemployeerequesttypeid",
  ADMIN_PAID_HOLIDAYS_SELECT: "/admin/paid_holidays/select",
  ADMIN_PAID_HOLIDAY_YEARS: "admin/paid_holidays/getyears",
  ADMIN_PAID_HOLIDAY_DETAIL: "admin/paid_holidays/get",
  ADMIN_ADD_CUSTOM_HOLIDAY: "/admin/paid_holidays/add_custom",
  ADMIN_UPDATE_CUSTOM_HOLIDAY: "/admin/paid_holidays/update_custom",
  ADMIN_ADD_LOAN_POLICY: "/admin/requests/add_loanpolicy",
  ADMIN_UPDATE_LOAN_POLICY: "/admin/requests/update_loanpolicy",
  ADMIN_DELETE_LOAN_POLICY: "/admin/requests/delete_loanpolicy",
  ADMIN_REMOVE_LOAN_POLICY: "/admin/requests/remove_loanpolicy",
  ADMIN_RESTORE_LOAN_POLICY: "/admin/requests/restore_loanpolicy",
  ADMIN_ADD_ADVANCE_POLICY: "/admin/requests/add_advancepolicy",
  ADMIN_UPDATE_ADVANCE_POLICY: "/admin/requests/update_advancepolicy",
  ADMIN_DELETE_ADVANCE_POLICY: "/admin/requests/delete_advancepolicy",
  ADMIN_REMOVE_ADVANCE_POLICY: "/admin/requests/remove_advancepolicy",
  ADMIN_RESTORE_ADVANCE_POLICY: "/admin/requests/restore_advancepolicy",
  ADMIN_CHECK_LOAN_POLICY: "/admin/requests/checkloanpolicy",
  ADMIN_CHECK_ADVANCE_POLICY: "/admin/requests/checkadvancepolicy",
  ADMIN_CHECK_LEAVE_POLICY: "/admin/requests/checkleavepolicy",
  ADMIN_CHECK_EXIT_POLICY: "/admin/requests/checkexitpolicy",
  ADMIN_CHECK_REDEPLOYMENT_POLICY: "/admin/requests/checkredeploymentpolicy",
  ADMIN_CHECK_DOCUMENT_POLICY: "/admin/requests/checkdocumentpolicy",
  ADMIN_ADD_EXIT_POLICY: "/admin/requests/add_exitpolicy",
  ADMIN_UPDATE_EXIT_POLICY: "/admin/requests/update_exitpolicy",
  ADMIN_DISABLE_EXIT_POLICY: "/admin/requests/disable_exitpolicy",
  ADMIN_ENABLE_EXIT_POLICY: "/admin/requests/enable_exitpolicy",
  ADMIN_ADD_LEAVE_POLICY: "/admin/requests/add_leavepolicy",
  ADMIN_UPDATE_LEAVE_POLICY: "/admin/requests/update_leavepolicy",
  ADMIN_DELETE_LEAVE_POLICY: "/admin/requests/delete_leavepolicy",
  ADMIN_REMOVE_LEAVE_POLICY: "/admin/requests/remove_leavepolicy",
  ADMIN_RESTORE_LEAVE_POLICY: "/admin/requests/restore_leavepolicy",
  ADMIN_ADD_DOCUMENT_POLICY: "/admin/requests/add_documentpolicy",
  ADMIN_UPDATE_DOCUMENT_POLICY: "/admin/requests/update_documentpolicy",
  ADMIN_SAVE_DOCUMENT_POLICY_CONTENT:
    "/admin/requests/save_documentpolicycontent",
  ADMIN_ADD_DOCUMENT_POLICY_ITEMS: "/admin/requests/add_documentpolicy_items",
  ADMIN_ADD_REDEPLOYMENT_POLICY: "/admin/requests/add_redeploymentpolicy",
  ADMIN_UPDATE_REDEPLOYMENT_POLICY: "/admin/requests/update_redeploymentpolicy",
  ADMIN_DISABLE_REDEPLOYMENT_POLICY:
    "/admin/requests/disable_redeploymentpolicy",
  ADMIN_ENABLE_REDEPLOYMENT_POLICY: "/admin/requests/enable_redeploymentpolicy",
  ADMIN_GET_ACCRUAL_TYPES: "/admin/requests/getaccrualtypes",
  ADMIN_LEAVE_POLICY_ITEM_EMPLOYEES:
    "/admin/employees/getleavepolicyitememployees",
  ADMIN_SURVEYS_GET: "/admin/surveys/get",
  ADMIN_FEDERAL_HOLIDAYS: "admin/paid_holidays/view/federal",
  ADMIN_UPDATE_FEDERAL_HOLIDAYS: "/admin/paid_holidays/update_federal",
  //Employee Profile Updates
  ADMIN_PENDING_EMPLOYEE_UPDATES: "/admin/employeeprofileupdates/pending",
  ADMIN_PROFILE_UPDATE_CONFIGURATION:
    "/admin/employeeprofileupdates/configuration",
  ADMIN_BATCH_EMPLOYEE_PROFILE_UPDATE_REVIEW:
    "/admin/employeeprofileupdates/batchreview",
  EMPLOYEE_PENDING_PROFILE_UPDATES: "/employee/profileupdates/pending",
  ADMIN_EMPLOYEE_PROFILE_UPDATE_REVIEWS: "/admin/employeeprofileupdates",
  APPROVAL_PROFILE_UPDATE_REVIEWS: "/employee/profileupdates/pendingreviews",
  APPROVAL_BATCH_PROFILE_UPDATE_REVIEW: "/employee/profileupdates/batchreview",
} as const

export const requestsService = {
  instanceKey: service.instanceKey,

  // Employee
  addLoanRequest: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADD_LOAN, body),
  addLeaveRequest: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADD_LEAVE, body),
  addExitRequest: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADD_EXIT, body),
  addRedeploymentRequest: (
    id: string | number,
    policyId: string | number,
    body: Record<string, any>
  ) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADD_REDEPLOYMENT}?id=${id}&redeployment_policy_id=${policyId}`,
      body
    ),
  addDocumentRequest: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADD_DOCUMENT, body),
  addAdvanceRequest: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADD_ADVANCE, body),
  uploadDocument: (formData: FormData) =>
    service.upload(REQUESTS_ENDPOINTS.UPLOAD_DOCUMENT, formData),
  /** Adds one payband, paygrade or group to a leave policy that already exists. */
  addLeavePolicyItem: (body: Record<string, string>) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_LEAVE_POLICY_ITEM, body),
  /** Employees a policy covers who hold no balance on it. Read-only. */
  selectMissingLeaveBalances: (leavePolicyId?: number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_MISSING_LEAVE_BALANCES, {
      leave_policy_id: leavePolicyId,
    }),
  selectLeaveRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_LEAVE_REQUESTS, params),
  /** Approved leave the signed-in employee is relieving, with each handover note. */
  selectRelieveRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_RELIEVE_REQUESTS, params),
  selectAdvanceRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_ADVANCE_REQUESTS, params),
  selectExitRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_EXIT_REQUESTS, params),
  selectDocumentRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_DOCUMENT_REQUESTS, params),
  selectLoanRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_LOAN_REQUESTS, params),
  selectRedeploymentRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_REDEPLOYMENT_REQUESTS, params),
  selectLeaveBalances: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_LEAVE_BALANCES, params),
  //Employee Profile Updates
  getEmployeeProfileUpdates: (params?: Record<string, any>) => {
    const { employeeProfileRequestIds, ...rest } = params ?? {}
    const query = new URLSearchParams(rest as Record<string, string>)
    if (Array.isArray(employeeProfileRequestIds)) {
      employeeProfileRequestIds.forEach((id) =>
        query.append("employeeProfileRequestIds", String(id))
      )
    }
    return service.get(
      `${REQUESTS_ENDPOINTS.ADMIN_PENDING_EMPLOYEE_UPDATES}?${query}`
    )
  },
  getEmployeeProfileUpdateConfiguration: () =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_PROFILE_UPDATE_CONFIGURATION),
  getMyPendingProfileUpdates: () =>
    service.get(REQUESTS_ENDPOINTS.EMPLOYEE_PENDING_PROFILE_UPDATES),
  reviewEmployeeProfileUpdate: (
    requestId: string | number,
    action: "approve" | "decline",
    note?: string
  ) =>
    service.post(`/admin/employeeprofileupdates/${requestId}/review`, {
      action,
      note: note || "",
    }),
  batchReviewEmployeeProfileUpdates: (
    requestIds: number[],
    action: "approve" | "decline",
    note?: string
  ) =>
    service.post(
      REQUESTS_ENDPOINTS.ADMIN_BATCH_EMPLOYEE_PROFILE_UPDATE_REVIEW,
      {
        employee_profile_update_request_ids: requestIds,
        action,
        note: note || "",
      }
    ),
  getEmployeeProfileUpdateReviews: (requestId: string | number) =>
    service.get(
      `${REQUESTS_ENDPOINTS.ADMIN_EMPLOYEE_PROFILE_UPDATE_REVIEWS}/${requestId}/reviews`
    ),
  getApprovalProfileUpdates: (params?: Record<string, any>) => {
    const { employeeProfileRequestIds, ...rest } = params ?? {}
    const query = new URLSearchParams(rest as Record<string, string>)
    if (Array.isArray(employeeProfileRequestIds)) {
      employeeProfileRequestIds.forEach((id) =>
        query.append("employeeProfileRequestIds", String(id))
      )
    }
    return service.get(
      `${REQUESTS_ENDPOINTS.APPROVAL_PROFILE_UPDATE_REVIEWS}?${query}`
    )
  },
  getApprovalProfileUpdateReviews: (requestId: string | number) =>
    service.get(
      `${REQUESTS_ENDPOINTS.APPROVAL_PROFILE_UPDATE_REVIEWS}/${requestId}/reviews`
    ),
  reviewApprovalProfileUpdate: (
    requestId: string | number,
    action: "approve" | "decline",
    note?: string
  ) =>
    service.post(`/employee/profileupdates/${requestId}/review`, {
      action,
      note: note || "",
    }),
  batchReviewApprovalProfileUpdates: (
    requestIds: number[],
    action: "approve" | "decline",
    note?: string
  ) =>
    service.post(REQUESTS_ENDPOINTS.APPROVAL_BATCH_PROFILE_UPDATE_REVIEW, {
      employee_profile_update_request_ids: requestIds,
      action,
      note: note || "",
    }),
  // Policies
  getLoanPolicies: () => service.get(REQUESTS_ENDPOINTS.GET_LOAN_POLICIES),
  getLeavePolicies: () => service.get(REQUESTS_ENDPOINTS.GET_LEAVE_POLICIES),
  getExitPolicies: () => service.get(REQUESTS_ENDPOINTS.GET_EXIT_POLICIES),
  getRedeploymentPolicies: () =>
    service.get(REQUESTS_ENDPOINTS.GET_REDEPLOYMENT_POLICIES),
  getDocumentPolicies: () =>
    service.get(REQUESTS_ENDPOINTS.GET_DOCUMENT_POLICIES),
  getAdvancePolicies: () =>
    service.get(REQUESTS_ENDPOINTS.GET_ADVANCE_POLICIES),

  // Admin
  adminGetLoanPolicies: (personId?: string | number) =>
    service.get(
      REQUESTS_ENDPOINTS.ADMIN_LOAN_POLICIES,
      personId ? { id: personId } : undefined
    ),
  adminGetLoanRequests: (
    statusId: number,
    params?: {
      pageNumber?: number
      pageSize?: number
      searchParams?: string
      [key: string]: any
    }
  ) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_LOAN_REQUESTS, {
      statusId,
      ...params,
    }),
  adminGetLeavePolicies: () =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_LEAVE_POLICIES),
  adminGetLeaveRequests: (
    statusId?: number,
    params?: {
      pageNumber?: number
      pageSize?: number
      searchParams?: string
      [key: string]: any
    }
  ) =>
    service.get(
      REQUESTS_ENDPOINTS.ADMIN_LEAVE_REQUESTS,
      statusId !== undefined ? { statusId, ...params } : params
    ),
  adminGetExitPolicies: () =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_EXIT_POLICIES),
  adminGetExitRequests: (
    statusId?: number,
    params?: {
      pageNumber?: number
      pageSize?: number
      searchParams?: string
      [key: string]: any
    }
  ) =>
    service.get(
      REQUESTS_ENDPOINTS.ADMIN_EXIT_REQUESTS,
      statusId !== undefined ? { statusId, ...params } : params
    ),
  adminGetExitSchedules: (
    statusId?: string | number,
    params?: {
      pageNumber?: number
      pageSize?: number
      searchParams?: string
      [key: string]: any
    }
  ) =>
    service.get(
      REQUESTS_ENDPOINTS.ADMIN_EXIT_SCHEDULES,
      statusId !== undefined ? { statusId, ...params } : params
    ),
  adminGetExitSurveys: () => service.get(REQUESTS_ENDPOINTS.ADMIN_EXIT_SURVEYS),
  adminGetAdvanceRequests: (params: any) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_ADVANCE_REQUESTS, params),
  getLoanRequestDetail: (id: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_GET_REQUEST, { id }),
  selectApprovalLeaveRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_APPROVAL_LEAVE_REQUESTS, params),
  selectApprovalLoanRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_APPROVAL_LOAN_REQUESTS, params),
  selectApprovalRedeploymentRequests: (params?: Record<string, any>) =>
    service.get(
      REQUESTS_ENDPOINTS.SELECT_APPROVAL_REDEPLOYMENT_REQUESTS,
      params
    ),
  selectApprovalAdvanceRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_APPROVAL_ADVANCE_REQUESTS, params),
  selectApprovalDocumentRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_APPROVAL_DOCUMENT_REQUESTS, params),
  selectApprovalExitRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.SELECT_APPROVAL_EXIT_REQUESTS, params),
  updateLeaveBalance: (body: Record<string, any>[]) =>
    service.post(REQUESTS_ENDPOINTS.UPDATE_LEAVE_BALANCE, body),

  // Admin request actions
  adminAddLoanRequest: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_LOAN, body),
  adminDeleteLoanRequest: (id: string | number) =>
    service.delete(`${REQUESTS_ENDPOINTS.ADMIN_DELETE_LOAN}?id=${id}`),
  adminToggleLoanRequest: (id: string | number, activate: boolean) =>
    service.post(
      `${
        activate
          ? REQUESTS_ENDPOINTS.ADMIN_ACTIVATE_LOAN
          : REQUESTS_ENDPOINTS.ADMIN_DEACTIVATE_LOAN
      }?id=${id}`
    ),
  adminBatchReviewRequests: (
    type: "Approve" | "Decline",
    isForPayroll: string | null,
    body: {
      employee_request_id: number | string
      note: string
    }[]
  ) => {
    const params = new URLSearchParams({ id: type })
    if (isForPayroll != null) params.set("is_for_payroll", isForPayroll)
    return service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_BATCH_REVIEW}?${params.toString()}`,
      body
    )
  },
  reviewRequest: (
    id: string | number,
    note: string,
    actionType: "Approve" | "Decline",
    isForPayroll?: string | null,
    deductFromPayroll?: string | null,
    surveyId?: string | number | null,
    /** TO-04. Required by the server when approving leave that breaches the overlap threshold. */
    overlapOverrideReason?: string | null
  ) => {
    const params = new URLSearchParams({
      id: String(id),
      note: note || "",
      actionType,
    })
    if (isForPayroll != null) params.set("is_for_payroll", isForPayroll)
    if (deductFromPayroll != null)
      params.set("deduct_from_payroll", deductFromPayroll)
    if (surveyId != null) params.set("survey_id", String(surveyId))
    if (overlapOverrideReason)
      params.set("overlap_override_reason", overlapOverrideReason)
    return service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_REVIEW}?${params.toString()}`
    )
  },
  adminAddLeaveRequest: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_LEAVE, body),
  adminDeleteLeaveRequest: (id: string | number) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_DELETE_LEAVE}?id=${id}`),
  adminAddAdvanceRequest: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_ADVANCE, body),
  adminDeleteAdvanceRequest: (id: string | number) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_DELETE_ADVANCE}?id=${id}`),
  adminAddExitRequest: (body: Record<string, any>, id?: string | number) =>
    service.post(
      id
        ? `${REQUESTS_ENDPOINTS.ADMIN_ADD_EXIT}?id=${id}`
        : REQUESTS_ENDPOINTS.ADMIN_ADD_EXIT,
      body
    ),
  adminDeleteExitRequest: (id: string | number) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_DELETE_EXIT}?id=${id}`),
  adminAddRedeploymentRequest: (
    id: string | number,
    policyId: string | number | undefined | null,
    body: Record<string, any>
  ) =>
    service.post(
      policyId != null
        ? `${REQUESTS_ENDPOINTS.ADMIN_ADD_REDEPLOYMENT}?id=${id}&redeployment_policy_id=${policyId}`
        : `${REQUESTS_ENDPOINTS.ADMIN_ADD_REDEPLOYMENT}?id=${id}`,
      body
    ),
  adminDeleteRedeploymentRequest: (id: number) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_DELETE_REDEPLOYMENT}?id=${id}`),
  adminAddDocumentRequest: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_DOCUMENT, body),
  adminDeleteDocumentRequest: (id: string | number) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_DELETE_DOCUMENT}?id=${id}`),
  adminUploadDocument: (formData: FormData) =>
    service.upload(REQUESTS_ENDPOINTS.ADMIN_UPLOAD_DOCUMENT, formData),
  getLeavePerks: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_SELECT_LEAVE_PERKS, params),
  getMaximumLoanAmount: (
    personId: string | number,
    policyId: string | number
  ) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_GET_MAX_LOAN_AMOUNT, {
      person_id: personId,
      loan_policy_id: policyId,
    }),
  getLeaveBalance: (personId: string | number, policyId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_GET_LEAVE_BALANCE, {
      person_id: personId,
      leave_policy_id: policyId,
    }),
  addWorkingDays: (date: string, workingDays?: number) => {
    const params = new URLSearchParams({ date })
    if (workingDays !== undefined)
      params.set("working_days", String(workingDays))
    return service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_ADD_WORKING_DAYS}?${params.toString()}`,
      {}
    )
  },
  adminGetRedeploymentRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_REDEPLOYMENT_REQUESTS, params),
  adminGetDocumentRequests: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_DOCUMENT_REQUESTS, params),
  adminGetRedeploymentSchedules: (params?: Record<string, any>) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_REDEPLOYMENT_SCHEDULES, params),

  // Advance toggle
  adminToggleAdvanceRequest: (id: string | number, activate: boolean) =>
    service.post(
      `${
        activate
          ? REQUESTS_ENDPOINTS.ADMIN_ADVANCE_ACTIVATE
          : REQUESTS_ENDPOINTS.ADMIN_ADVANCE_DEACTIVATE
      }?id=${id}`
    ),
  getMaximumAdvanceAmount: (
    personId: string | number,
    policyId: string | number
  ) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_GET_MAX_ADVANCE_AMOUNT, {
      person_id: personId,
      advance_policy_id: policyId,
    }),
  adminGetAdvancePolicies: (personId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_ADVANCE_POLICIES, { id: personId }),

  // Leave perks
  addLeavePerk: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_LEAVE_PERK, body),
  updateLeavePerk: (id: string | number, body: Record<string, any>) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_UPDATE_LEAVE_PERK}?id=${id}`,
      body
    ),
  deleteLeavePerk: (id: string | number, comment?: string) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_DELETE_LEAVE_PERK}?id=${id}${
        comment != null ? `&comment=${encodeURIComponent(comment)}` : ""
      }`
    ),
  removeLeavePerk: (id: string | number) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_REMOVE_LEAVE_PERK}?id=${id}`),
  restoreLeavePerk: (id: string | number) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_RESTORE_LEAVE_PERK}?id=${id}`),

  // FormData upload variants for Create* pages
  addLeaveRequestForm: (formData: FormData) =>
    service.upload(REQUESTS_ENDPOINTS.ADD_LEAVE, formData),
  adminAddLeaveRequestForm: (formData: FormData) =>
    service.upload(REQUESTS_ENDPOINTS.ADMIN_ADD_LEAVE, formData),
  adminAddAdvanceRequestForm: (formData: FormData) =>
    service.upload(REQUESTS_ENDPOINTS.ADMIN_ADD_ADVANCE, formData),
  adminAddExitRequestForm: (formData: FormData, id?: string | number) =>
    service.upload(
      id
        ? `${REQUESTS_ENDPOINTS.ADMIN_ADD_EXIT}?id=${id}`
        : REQUESTS_ENDPOINTS.ADMIN_ADD_EXIT,
      formData
    ),
  adminAddDocumentRequestForm: (formData: FormData) =>
    service.upload(REQUESTS_ENDPOINTS.ADMIN_ADD_DOCUMENT, formData),
  adminAddRedeploymentRequestForm: (
    id: string | number,
    policyId: string | number,
    formData: FormData
  ) =>
    service.upload(
      `${REQUESTS_ENDPOINTS.ADMIN_ADD_REDEPLOYMENT}?id=${id}&redeployment_policy_id=${policyId}`,
      formData
    ),

  // Document / redeployment / exit helpers
  getDocumentContent: (policyId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_GET_DOC_CONTENT, {
      document_policy_id: policyId,
    }),
  adminGetRedeploymentPolicies: (forEmployee = false) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_REDEPLOYMENT_POLICIES, {
      forEmployee,
    }),
  getRedeploymentDepartments: (personId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_REDEPLOYMENT_DEPTS, { id: personId }),
  getRedeploymentOfficeAddresses: (personId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_REDEPLOYMENT_ADDRESSES, {
      id: personId,
    }),
  getRedeploymentNoticePeriod: (
    locationId: string | number,
    personId: string | number,
    policyId: string | number
  ) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_REDEPLOYMENT_NOTICE_PERIOD, {
      id: locationId,
      person_id: personId,
      redeployment_policy_id: policyId,
    }),
  getExitNoticePeriod: (personId: string | number, policyId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_EXIT_NOTICE_PERIOD, {
      person_id: personId,
      exit_policy_id: policyId,
    }),
  getLeaveRelievers: (
    personId: string | number,
    startDate: string,
    endDate: string
  ) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_LEAVE_RELIEVERS, {
      person_id: personId,
      leaveStartDate: startDate,
      leaveEndDate: endDate,
    }),
  getEmployeeLeaveRelievers: (
    personId: string | number,
    startDate: string,
    endDate: string
  ) =>
    service.get(REQUESTS_ENDPOINTS.EMPLOYEE_LEAVE_RELIEVERS, {
      person_id: personId,
      leaveStartDate: startDate,
      leaveEndDate: endDate,
    }),
  adminGetLeavePoliciesForPerson: (personId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_LEAVE_POLICIES_FOR_PERSON, {
      id: personId,
    }),
  adminGetExitPoliciesForPerson: (personId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_EXIT_POLICIES, { id: personId }),
  adminGetPoliciesByRequestType: (requestTypeId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_POLICIES_BY_REQUEST_TYPE, {
      id: requestTypeId,
    }),
  adminGetDocumentPolicies: (personId: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_DOCUMENT_POLICIES, {
      id: personId,
      forEmployee: false,
    }),
  getDocumentContentForPerson: (
    personId: string | number,
    policyId: string | number
  ) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_GET_DOC_CONTENT, {
      person_id: personId,
      document_policy_id: policyId,
    }),
  importExits: (formData: FormData) =>
    service.upload(REQUESTS_ENDPOINTS.ADMIN_IMPORT_EXITS, formData),
  importRedeployments: (formData: FormData) =>
    service.upload(REQUESTS_ENDPOINTS.ADMIN_IMPORT_REDEPLOYMENTS, formData),
  getLeaveHolidays: () =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_LEAVE_HOLIDAYS, { id: "new_request" }),

  // Loan / Advance policy view
  viewLoanPolicies: (
    params?: {
      searchParams?: string
      pageNumber?: number
      pageSize?: number
    } & Record<string, any>
  ) => service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_LOAN_POLICIES, params),
  viewLoanPolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_LOAN_POLICIES, {
      id: "policy",
      x: key,
    }),
  editLoanPolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_LOAN_POLICIES, {
      id: "edit",
      x: key,
    }),
  viewSalaryAdvancePolicies: (
    params?: {
      searchParams?: string
      pageNumber?: number
      pageSize?: number
    } & Record<string, any>
  ) => service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_ADVANCE_POLICIES, params),
  viewSalaryAdvancePolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_ADVANCE_POLICIES, {
      id: "policy",
      x: key,
    }),
  editSalaryAdvancePolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_ADVANCE_POLICIES, {
      id: "edit",
      x: key,
    }),

  // Loan policy CRUD
  addLoanPolicy: (body: any) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_LOAN_POLICY, body),
  updateLoanPolicy: (id: string | number, body: any) =>
    service.patch(
      `${REQUESTS_ENDPOINTS.ADMIN_UPDATE_LOAN_POLICY}?id=${id}`,
      body as any
    ),
  deleteLoanPolicy: (id: string, comment: string) =>
    service.delete(
      `${
        REQUESTS_ENDPOINTS.ADMIN_DELETE_LOAN_POLICY
      }?id=${id}&comment=${encodeURIComponent(comment)}`
    ),
  removeLoanPolicy: (id: string) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_REMOVE_LOAN_POLICY}?id=${id}`),
  restoreLoanPolicy: (id: string) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_RESTORE_LOAN_POLICY}?id=${id}`),

  // Advance policy CRUD
  addAdvancePolicy: (body: any) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_ADVANCE_POLICY, body),
  updateAdvancePolicy: (id: string | number, body: any) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_UPDATE_ADVANCE_POLICY}?id=${id}`,
      body
    ),
  deleteAdvancePolicy: (id: string, comment: string) =>
    service.post(
      `${
        REQUESTS_ENDPOINTS.ADMIN_DELETE_ADVANCE_POLICY
      }?id=${id}&comment=${encodeURIComponent(comment)}`
    ),
  removeAdvancePolicy: (id: string) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_REMOVE_ADVANCE_POLICY}?id=${id}`),
  restoreAdvancePolicy: (id: string) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_RESTORE_ADVANCE_POLICY}?id=${id}`),

  // Policy name validation
  checkLoanPolicy: (description: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_CHECK_LOAN_POLICY, { description }),
  checkAdvancePolicy: (description: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_CHECK_ADVANCE_POLICY, { description }),
  checkLeavePolicy: (description: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_CHECK_LEAVE_POLICY, { description }),
  checkExitPolicy: (description: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_CHECK_EXIT_POLICY, { description }),
  checkRedeploymentPolicy: (description: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_CHECK_REDEPLOYMENT_POLICY, {
      description,
    }),

  // Exit policy view
  viewExitPolicies: (
    params?: {
      searchParams?: string
      pageNumber?: number
      pageSize?: number
    } & Record<string, any>
  ) => service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_EXIT_POLICIES, params),
  viewExitPolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_EXIT_POLICIES, {
      id: "policy",
      x: key,
    }),
  editExitPolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_EXIT_POLICIES, {
      id: "edit",
      x: key,
    }),

  // Redeployment policy view / CRUD
  viewRedeploymentPolicies: (
    params?: {
      searchParams?: string
      pageNumber?: number
      pageSize?: number
    } & Record<string, any>
  ) => service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_REDEPLOYMENT_POLICIES, params),
  viewRedeploymentPolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_REDEPLOYMENT_POLICIES, {
      id: "policy",
      x: key,
    }),
  editRedeploymentPolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_REDEPLOYMENT_POLICIES, {
      id: "edit",
      x: key,
    }),
  addRedeploymentPolicy: (body: any) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_REDEPLOYMENT_POLICY, body),
  updateRedeploymentPolicy: (id: string | number, body: any) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_UPDATE_REDEPLOYMENT_POLICY}?id=${id}`,
      body
    ),
  disableRedeploymentPolicy: (id: string, comment: string) =>
    service.post(
      `${
        REQUESTS_ENDPOINTS.ADMIN_DISABLE_REDEPLOYMENT_POLICY
      }?id=${id}&comment=${encodeURIComponent(comment)}`
    ),
  enableRedeploymentPolicy: (id: string) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_ENABLE_REDEPLOYMENT_POLICY}?id=${id}`
    ),

  // Exit policy CRUD
  addExitPolicy: (body: any) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_EXIT_POLICY, body),
  updateExitPolicy: (id: string | number, body: any) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_UPDATE_EXIT_POLICY}?id=${id}`,
      body
    ),
  disableExitPolicy: (id: string, comment: string) =>
    service.post(
      `${
        REQUESTS_ENDPOINTS.ADMIN_DISABLE_EXIT_POLICY
      }?id=${id}&comment=${encodeURIComponent(comment)}`
    ),
  enableExitPolicy: (id: string) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_ENABLE_EXIT_POLICY}?id=${id}`),

  // Surveys
  getSurveys: (id: string | number) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_SURVEYS_GET, { id }),

  // Document policy view / CRUD
  viewDocumentPolicies: (
    params?: {
      searchParams?: string
      pageNumber?: number
      pageSize?: number
    } & Record<string, any>
  ) => service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_DOCUMENT_POLICIES, params),
  viewDocumentPolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_DOCUMENT_POLICIES, {
      id: "policy",
      x: key,
    }),
  editDocumentPolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_DOCUMENT_POLICIES, {
      id: "edit",
      x: key,
    }),
  addDocumentPolicy: (body: any) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_DOCUMENT_POLICY, body),
  updateDocumentPolicy: (body: any) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_UPDATE_DOCUMENT_POLICY, body),
  deleteDocumentPolicy: (id: string, comment: string) =>
    service.post(
      `${
        REQUESTS_ENDPOINTS.ADMIN_DELETE_DOCUMENT_POLICY
      }?id=${id}&comment=${encodeURIComponent(comment)}`
    ),
  removeDocumentPolicy: (id: string) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_REMOVE_DOCUMENT_POLICY}?id=${id}`),
  restoreDocumentPolicy: (id: string) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_RESTORE_DOCUMENT_POLICY}?id=${id}`
    ),
  saveDocumentPolicyContent: (body: any) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_SAVE_DOCUMENT_POLICY_CONTENT, body),
  addDocumentPolicyItems: (id: string | number, body: any) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_ADD_DOCUMENT_POLICY_ITEMS}?id=${id}`,
      body
    ),
  checkDocumentPolicy: (description: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_CHECK_DOCUMENT_POLICY, {
      description,
    }),

  // Leave policy view / CRUD
  viewLeavePolicies: (
    params?: {
      searchParams?: string
      pageNumber?: number
      pageSize?: number
    } & Record<string, any>
  ) => service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_LEAVE_POLICIES, params),
  viewLeavePolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_LEAVE_POLICIES, {
      id: "policy",
      x: key,
    }),
  editLeavePolicy: (key: string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_VIEW_LEAVE_POLICIES, {
      id: "edit",
      x: key,
    }),
  addLeavePolicy: (body: any) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_LEAVE_POLICY, body),
  updateLeavePolicy: (id: string | number, body: any) =>
    service.post(
      `${REQUESTS_ENDPOINTS.ADMIN_UPDATE_LEAVE_POLICY}?id=${id}`,
      body
    ),
  deleteLeavePolicy: (id: string, comment: string) =>
    service.post(
      `${
        REQUESTS_ENDPOINTS.ADMIN_DELETE_LEAVE_POLICY
      }?id=${id}&comment=${encodeURIComponent(comment)}`
    ),
  removeLeavePolicy: (id: string) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_REMOVE_LEAVE_POLICY}?id=${id}`),
  restoreLeavePolicy: (id: string) =>
    service.post(`${REQUESTS_ENDPOINTS.ADMIN_RESTORE_LEAVE_POLICY}?id=${id}`),

  // Leave policy helpers
  getAccrualTypes: () =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_GET_ACCRUAL_TYPES),
  getLeavePolicyItemEmployees: (params: {
    policy_type_id: string
    leave_policy_id: string
    gender_id: string
    policy_group_id_list: string
    items: Record<string, string>[]
  }) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_LEAVE_POLICY_ITEM_EMPLOYEES, params),

  // Paid holidays
  getPaidHolidays: (year: number | string) =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_PAID_HOLIDAYS_SELECT, { year }),
  getPaidHolidayYears: () =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_PAID_HOLIDAY_YEARS),
  getPaidHolidayDetail: (id: string) =>
    service.get(`${REQUESTS_ENDPOINTS.ADMIN_PAID_HOLIDAY_DETAIL}?id=${id}`),
  addCustomHoliday: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_ADD_CUSTOM_HOLIDAY, body),
  updateCustomHoliday: (body: Record<string, any>) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_UPDATE_CUSTOM_HOLIDAY, body),
  deleteCustomHoliday: (id: string) =>
    service.delete(`/admin/paid_holidays/${id}/delete_custom`),
  getFederalHolidays: () =>
    service.get(REQUESTS_ENDPOINTS.ADMIN_FEDERAL_HOLIDAYS),
  updateFederalHolidays: (holidays: string[]) =>
    service.post(REQUESTS_ENDPOINTS.ADMIN_UPDATE_FEDERAL_HOLIDAYS, {
      holidays,
    }),
}
